import { render, staticRenderFns } from "./BlockQuestion.vue?vue&type=template&id=33a763e0&scoped=true"
import script from "./BlockQuestion.vue?vue&type=script&lang=js"
export * from "./BlockQuestion.vue?vue&type=script&lang=js"
import style0 from "./BlockQuestion.vue?vue&type=style&index=0&id=33a763e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a763e0",
  null
  
)

export default component.exports